// Taken from https://personal.sron.nl/~pault/#fig:scheme_muted
export const defaultColorPalette = [
    '#CC6677',
    '#332288',
    '#DDCC77',
    '#117733',
    '#88CCEE',
    '#882255',
    '#44AA99',
    '#999933',
    '#AA4499',
];
//# sourceMappingURL=palette.js.map